import { render, staticRenderFns } from "./PrechatForm.vue?vue&type=template&id=acc7d2b0&scoped=true&"
import script from "./PrechatForm.vue?vue&type=script&lang=js&"
export * from "./PrechatForm.vue?vue&type=script&lang=js&"
import style0 from "./PrechatForm.vue?vue&type=style&index=0&id=acc7d2b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc7d2b0",
  null
  
)

export default component.exports